export const getSubdomain = () => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const subdomain = host.split('.')[0];
    const isSpecialSubdomain = ['awx', 'wyngs-my', 'ae', 'wal', 'localhost', 'uat-speedbox', 'localhost'].includes(
      subdomain,
    );
    return isSpecialSubdomain;
  }
  return false;
};

export const isDutyChargesAllowedSubdomain = (): boolean => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const subdomain = host.split('.')[0];
    return ['ae', 'preprod', 'brightlinkers', 'localhost'].includes(subdomain);
  }
  return false;
};
export const getUsernameFromEmail = (email: string): string => {
  if (!email || !email.includes('@')) {
    return '';
  }
  return email.split('@')[0]; // Extract and return the part before '@'
};

let hasLoggedComplianceSubdomain = false;

/**
 * Returns true if compliance features (EU Compliance, US CPSC, Product ID/Type, Recipient VAT)
 * should be enabled for the current subdomain.
 * Only active on 'ae', 'pari', and 'preprod' (plus 'localhost' / '127.0.0.1' for development).
 */
export const isComplianceSubdomain = (customHostname?: string): boolean => {
  if (typeof window === 'undefined' && !customHostname) return false;
  const host = (customHostname || (typeof window !== 'undefined' ? window.location?.hostname : '') || '')
    .trim()
    .toLowerCase();
  if (!host) return false;

  const isLocal = host === 'localhost' || host === '127.0.0.1';
  const subdomain = host.split('.')[0];
  const isAllowed = isLocal || ['ae', 'pari', 'preprod'].includes(subdomain);

  if (!hasLoggedComplianceSubdomain && typeof window !== 'undefined' && !customHostname) {
    hasLoggedComplianceSubdomain = true;
    // TODO: remove after verification
    console.info(`[ComplianceSubdomainGate] host="${host}", subdomain="${subdomain}", enabled=${isAllowed}`);
  }

  return isAllowed;
};

/**
 * Returns true if the subdomain is exempt from requiring Purpose Of Shipment.
 * Only 'wyngs' and 'wal' (including 'wyngs-my') subdomains are exempt.
 */
export const isPurposeOfShipmentExemptSubdomain = (customHostname?: string): boolean => {
  if (typeof window === 'undefined' && !customHostname) return false;
  const host = (customHostname || (typeof window !== 'undefined' ? window.location?.hostname : '') || '')
    .trim()
    .toLowerCase();
  if (!host) return false;
  const subdomain = host.split('.')[0];
  return ['wyngs', 'wyngs-my', 'wal'].includes(subdomain);
};

/**
 * Single source of truth for whether Purpose Of Shipment is required.
 * - Exempt if shipment type is 'document' (all subdomains)
 * - Exempt if subdomain is 'wyngs' or 'wal'
 * - Required otherwise
 */
export const isPurposeOfShipmentRequired = (
  shipmentType?: string | { type?: string },
  customHostname?: string,
): boolean => {
  const typeStr = typeof shipmentType === 'string' ? shipmentType : shipmentType?.type;
  const isDocument = (typeStr || '').trim().toLowerCase() === 'document';
  if (isDocument) return false;
  if (isPurposeOfShipmentExemptSubdomain(customHostname)) return false;
  return true;
};

/**
 * Returns true if the current subdomain is 'awx'.
 */
export const isAwxSubdomain = (customHostname?: string): boolean => {
  if (typeof window === 'undefined' && !customHostname) return false;
  const host = (customHostname || (typeof window !== 'undefined' ? window.location?.hostname : '') || '')
    .trim()
    .toLowerCase();
  if (!host) return false;
  const subdomain = host.split('.')[0];
  return subdomain === 'awx';
};

/**
 * Returns true if the subdomain should default Shipment Mode to 'b2b' on fresh create.
 * Only 'wyngs', 'my-wyngs' (and 'wyngs-my'), and 'wal' subdomains default to 'b2b'.
 */
export const isShipmentModeDefaultB2BSubdomain = (customHostname?: string): boolean => {
  if (typeof window === 'undefined' && !customHostname) return false;
  const host = (customHostname || (typeof window !== 'undefined' ? window.location?.hostname : '') || '')
    .trim()
    .toLowerCase();
  if (!host) return false;
  const subdomain = host.split('.')[0];
  return ['wyngs', 'my-wyngs', 'wyngs-my', 'wal'].includes(subdomain);
};
